import { useSelectedOrganization } from './useSelectedOrganization';
import { useMemo } from 'react';

export const useMobileApps = () => {
  const org = useSelectedOrganization();
  const allApps = useMemo(() => org.selectedOrganization?.mobileApps || [], [org]);

  return useMemo(() => {
    const connectedApps = allApps.filter(app => app.connected);
    const disconnectedApps = allApps.filter(app => !app.connected);
    const allAndroidApps = allApps.filter(app => app.__typename === 'AndroidApp');
    const connectedAndroidApps = allAndroidApps.filter(app => app.connected);
    const disconnectedAndroidApps = allAndroidApps.filter(app => !app.connected);
    const allIosApps = allApps.filter(app => app.__typename === 'IosApp');
    const connectedIosApps = allIosApps.filter(app => app.connected);
    const disconnectedIosApps = allIosApps.filter(app => !app.connected);

    return {
      allApps,
      connectedApps,
      disconnectedApps,
      allAndroidApps,
      connectedAndroidApps,
      disconnectedAndroidApps,
      allIosApps,
      connectedIosApps,
      disconnectedIosApps
    };
  }, [allApps]);
};
